/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

const requireModule = require.context('../core', true,  /\.store\.js$/);
const modules = {};

requireModule.keys().forEach(filename => {
	// create the module name from fileName
	// remove the store.store.js extension and capitalize

	//extract the name like this: ./some/folder/path/moduleName.store.js
	let moduleName = filename.split("/").slice(-1)[0].split(".store.js")[0];
	modules[moduleName] = requireModule(filename).default || requireModule(filename);
});

export default modules;
